import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import { Box, Button } from "@mui/material";
import axios from "axios";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_EXISTS,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import Select from "react-select";

function InventoryStockStatus() {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const Location = localStorage.getItem("Location");
  const [selectedModule, setSelectedModule] = useState([]);
  const [selectedModuleValue, setSelectedModuleValue] = useState(null);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [slugCategroryList, setSlugCategroryList] = useState([]);
  const [formData, setFormData] = useState({
    id: 0,
    slug: "",
    categoryId: "",
    type: 0, // 1 mean Local, 2 mean wholesale, 3 mean all
    isDelete: 0,
  });

  console.log(slugCategroryList, "slugCategroryList");
  console.log(formData, "formData");
  const actionType = [
    { value: 0, label: "All" },
    { value: 1, label: "Customer" },
    { value: 2, label: "Wholesale" },
    // { value: 3, label: "remove Both" },
  ];

  const closeModel = () => {
    setFormData({
      id: 0,
      slug: "",
      categoryId: "",
      type: 0, // 1 mean Local, 2 mean wholesale, 3 mean all
      isDelete: 0,
    });
  };

  // const handleSwitchOnOff = (categoryId, type) => {
  //   let isShowOnInventoryStockStatus = 0;
  //   let isShowOnWholesaleInventoryStockStatus = 0;
  //   if (type === 1) {
  //     isShowOnInventoryStockStatus = 1;
  //   } else if (type === 2) {
  //     isShowOnWholesaleInventoryStockStatus = 1;
  //   } else if (type === 0) {
  //     isShowOnInventoryStockStatus = 1;
  //     isShowOnWholesaleInventoryStockStatus = 1;
  //   } else if (type === 3) {
  //     isShowOnInventoryStockStatus = 0;
  //     isShowOnWholesaleInventoryStockStatus = 0;
  //   }

  //   const updatedData = categoryData.map((el) => {
  //     if (el.ID === categoryId) {
  //       return {
  //         ...el,
  //         isShowOnInventoryStockStatus: isShowOnInventoryStockStatus,
  //         isShowOnWholesaleInventoryStockStatus:
  //           isShowOnWholesaleInventoryStockStatus,
  //       };
  //     } else {
  //       return el;
  //     }
  //   });
  //   setCategoryData(updatedData);
  // };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
    },
    {
      header: "Slug",
      accessorKey: "slug",
    },
    {
      header: "Categories",
      accessorKey: "categoriesId",
      Cell: ({ row }) => {
        const categoryIds = row.original.categoriesId.split(",");
        const categoryNames = categoryData
          .filter((category) => categoryIds.includes(category.ID.toString()))
          .map((category) => category.Name)
          .join(", ");
        return <span>{categoryNames}</span>;
      },
    },
    {
      header: "Action",
      accessorKey: "action",
      Cell: ({ row }) =>
        (row.original.isShowOnPublicInventoryStockStatus === 1 ||
          row.original.isShowOnWholesaleInventoryStockStatus === 1) && (
          <Link
            className="btn btn-primary"
            to={`/inventory-stock-status-by-category?categoryId=${row.original?.categoriesId}&categoryName=${row.original?.slug}`}
          >
            Manage Items
          </Link>
        ),
    },
    {
      header: "View Customer",
      accessorKey: "ViewCustomer",
      Cell: ({ row }) => {
        // const lastCategory = row.original.Name?.split(">").pop().trim();
        // const formattedCategory = lastCategory.replace(/\s+/g, "_");
        const url = `${config.ecommWebsiteUrl}/inventory-stock-status/c/${row.original?.slug}`;

        return (
          row.original.isShowOnPublicInventoryStockStatus === 1 && (
            <Link className="btn btn-primary" to={url} target="_blank">
              View Customer
            </Link>
          )
        );
      },
    },
    {
      header: "View Wholesale",
      accessorKey: "ViewWholesale",
      Cell: ({ row }) => {
        // const lastCategory = row.original.Name?.split(">").pop().trim();
        // const formattedCategory = lastCategory.replace(/\s+/g, "_");
        const url = `${config.ecommWebsiteUrl}/inventory-stock-status/w/${row.original?.slug}`;

        return (
          row.original.isShowOnWholesaleInventoryStockStatus === 1 && (
            <Link className="btn btn-primary" to={url} target="_blank">
              View Wholesale
            </Link>
          )
        );
      },
    },
    {
      header: "Edit/Delete",
      accessorKey: "editdelete",
      Cell: ({ row }) => {
        return (
          <div>
            <Link
              className="btn btn-primary mr-2"
              to="#"
              data-bs-target="#CategoryAddPubliModel"
              data-bs-toggle="modal"
              onClick={() => {
                setFormData({
                  ...formData,
                  id: row.original.id,
                  slug: row.original.slug,
                  categoryId: row.original.categoriesId,
                  type:
                    row.original.isShowOnPublicInventoryStockStatus === 1 &&
                    row.original.isShowOnWholesaleInventoryStockStatus === 1
                      ? 0
                      : row.original.isShowOnPublicInventoryStockStatus === 1
                      ? 1
                      : 2,
                  isDelete: 0,
                });
              }}
            >
              Edit
            </Link>
            <Link
              className="btn btn-primary"
              to="#"
              onClick={() => {
                updateCategoryShowInventoryStockStatus(
                  row.original.categoriesId,
                  3,
                  row.original.slug,
                  1,
                  row.original.id
                );
              }}
            >
              X
            </Link>
          </div>
        );
      },
    },
  ];

  console.log(categoryData, "categoryData");

  const handleInventoryStockStatusList = () => {
    setLoading(true);
    axios
      .get(
        `${config.categoriesBaseUrl}/categories/inventoryStockStatusCategoriesList?selectedSite=${selectedModuleValue?.value}`
      )
      .then((res) => {
        setSlugCategroryList(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleListData = () => {
    setLoading(true);
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoryData(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const updateCategoryShowInventoryStockStatus = (
    categoryId,
    type,
    slug,
    isDelete,
    id
  ) => {
    let isShowOnInventoryStockStatus = 0;
    let isShowOnWholesaleInventoryStockStatus = 0;
    if (type === 1) {
      isShowOnInventoryStockStatus = 1;
    } else if (type === 2) {
      isShowOnWholesaleInventoryStockStatus = 1;
    } else if (type === 0) {
      isShowOnInventoryStockStatus = 1;
      isShowOnWholesaleInventoryStockStatus = 1;
    } else if (type === 3) {
      isShowOnInventoryStockStatus = 0;
      isShowOnWholesaleInventoryStockStatus = 0;
    }

    setLoading(true);
    axios
      .post(
        `${config.categoriesBaseUrl}/categories/updateIsShowOnInventoryStockStatus`,
        {
          id: id || 0,
          slug,
          categoryId,
          isShowOnInventoryStockStatus,
          isShowOnWholesaleInventoryStockStatus,
          isDelete,
          loginUserId,
          selectedSite: selectedModuleValue?.value,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseCode);
          handleInventoryStockStatusList();
          closeModel();
          console.log("SetDone");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
        } else {
          toastError(ERROR_MESSAGE);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleGetData = () => {
    setLoading(true);

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/getmultisitelist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;
        console.log(responseData, "check data of dynamic code");
        // Transform for Select options
        const options = responseData.map((item) => ({
          label: item.AppConfigvalue.trim(),
          value: item.AppConfigkey.trim(),
        }));

        setSelectedModule(options);

        // Set default to MainSite
        const defaultOption = options.find(
          (option) => option.value === "MainSite"
        );
        setSelectedModuleValue(defaultOption || null);

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData();
    handleInventoryStockStatusList();
    handleGetData();
  }, []);

  useEffect(() => {
    // handleListData();
    handleInventoryStockStatusList();
    // handleGetData();
  }, [selectedModuleValue?.value]);

  const handleDynamicModuleChange = (selected) => {
    setSelectedModuleValue(selected);
  };

  console.log(selectedModuleValue, "selectedModuleValue123")
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Ecom Inventory Stock Status</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="row">
               <div className="col-auto">
                 <h4 className="card-title mb-0">
                  Category Wise Inventory Stock Status
                </h4>
               </div>
               <div className="ms-auto col-auto">
                 <div className="d-flex gap-2 align-items-center">
                  <div style={{ minWidth: "400px" }} className="mb-3 mr-2">
                    <label>Select Site</label>
                    <Select
                      options={selectedModule}
                      value={selectedModuleValue}
                      onChange={handleDynamicModuleChange}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="ConfigDynamic"
                      name="ConfigDynamic"
                      className="custom-search-select"
                    />
                  </div>

                  <Link
                    className="btn btn-primary mr-2"
                    to="#"
                    // onClick={() => {
                    //   navigate("/add-category");
                    // }}
                    data-bs-target="#CategoryAddPubliModel"
                    data-bs-toggle="modal"
                  >
                    Add Category
                  </Link>
                  
                  <Link
                    className="btn btn-primary"
                    to={`${config.ecommWebsiteUrl}/iss`}
                    target="_blank"
                  >
                    View Inventory Links
                  </Link>
                </div>
               </div>
              </div>

              <div>
                <CommonMatrialReactTable
                  columns={columns}
                  data={slugCategroryList}
                  hodiExport={true}
                  enableRowSelection={false}
                  isRowSelectionManual={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="CategoryAddPubliModel"
        tabIndex="-1"
        aria-labelledby="CategoryAddPubliModelLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title" id="CategoryAddPubliModelLabel">
                Add to Inventory Stock Status
                <div className="mt-2 d-flex">
                <label>Selected Site: </label>
                <p className="ml-1">{selectedModuleValue?.label}</p>
              </div>
              </p>
              
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModel()}
              ></button>

              <div >
              
            </div>
            </div>
            
            <div className="modal-body">
              <div className="mb-3">
                <label>Slug</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Slug"
                  onChange={(e) => {
                    const cSlug = e.target.value
                      .toLocaleLowerCase()
                      .replace(/\s+/g, "-");
                    setFormData({
                      ...formData,
                      slug: cSlug,
                    });
                  }}
                  value={formData.slug}
                />
              </div>
              <div className="mb-3">
                <label>Select Categroy</label>
                <Select
                  isMulti
                  options={categoryData.map((item) => ({
                    value: item.ID.toString(), // Ensure value is always string for consistency
                    label: item.Name,
                  }))}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Category"
                  onChange={(selectedOptions) => {
                    const selectedIds =
                      selectedOptions?.map((item) => item.value).join(",") ||
                      "";
                    setFormData({
                      ...formData,
                      categoryId: selectedIds,
                    });
                  }}
                  value={categoryData
                    .filter((item) =>
                      formData.categoryId
                        ?.split(",")
                        .includes(item.ID.toString())
                    )
                    .map((item) => ({
                      value: item.ID.toString(),
                      label: item.Name,
                    }))}
                  isClearable={false}
                />
              </div>
              <div className="mb-3">
                <label>Select Action Type</label>
                <Select
                  // isMulti
                  options={actionType}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Action Type"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      type: e.value,
                    });
                  }}
                  value={actionType.find(
                    (option) => option.value === formData.type
                  )}
                  isClearable={false}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => closeModel()}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  updateCategoryShowInventoryStockStatus(
                    formData.categoryId,
                    formData.type,
                    formData.slug,
                    0,
                    formData.id
                  );
                }}
              >
                Save Category
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InventoryStockStatus;
